const initialState = { isSelected: null, reselectNonce: 0 };

const panoramicPmSelection = (state, action) => {
  const current = state === undefined ? initialState : (state.panoramicPmSelection ?? initialState);

  switch (action.type) {
    case "SET_PANORAMIC_PM_SELECTED":
      if (current.isSelected === action.payload) {
        return current;
      }
      return { ...current, isSelected: action.payload };
    case "REQUEST_PANORAMIC_PM_RESELECT":
      return { ...current, reselectNonce: current.reselectNonce + 1 };
    default:
      return current;
  }
};

export { panoramicPmSelection };
